import React from 'react';
import { Navbar } from '../../elements/Navbar';
import { Footer } from '../../elements/Footer';
import { Header } from '../../elements/Header';
import { Info } from '../../elements/Info';

const LandingPage = () => {
  return (
    <div data-testid = 'landing-page'>
      <Navbar />
      <Header />
      <Info />
      <Footer />
    </div>
  );
}
  
export default LandingPage;
